import * as React from "react";

import * as styles from "../LeftMenu.module.less";
import { LeftMenuExternalLinkItem } from "../LeftMenuItem";

export type ExternalLinkItemProps = {
  item: LeftMenuExternalLinkItem;
};

export const ExternalLinkItem = ({ item }: ExternalLinkItemProps) => (
  <a
    href={item.url}
    target="_blank"
    rel="noopener noreferrer"
    className={styles.menuItem}
  >
    {item.icon}
    <span className={styles.label}>{item.label}</span>
  </a>
);
